import { PlusInSquareIcon } from "assets/icons";
import { t } from "i18next";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { Button, FormField, Input } from "ui";

import { useGetDeliveryZones } from "../../../../../common/apis";
import { DeliveryZonesFields } from "../atoms";
import {
  PriorityZonesBlockProps,
  DriverFormValues
} from "../DriverDetailsForm.types";

import styles from "../DriverDetailsForm.module.scss";

export const PriorityZonesBlock = ({}: PriorityZonesBlockProps) => {
  const { control } = useFormContext<DriverFormValues>();
  const {
    fields: deliveryZones,
    append: appendDeliveryZone,
    remove: removeDeliveryZone
  } = useFieldArray<DriverFormValues, "deliveryZones", "id">({
    control,
    name: "deliveryZones",
    keyName: "id"
  });
  const onAppendDeliveryZone = () => {
    appendDeliveryZone({
      id: "",
      value: ""
    });
  };

  const {
    deliveryZones: deliveryZonesOptions,
    isLoading: isDeliveryZonesLoading
  } = useGetDeliveryZones();

  return (
    <div className={styles.driverForm__block}>
      <h4 className={styles.driverForm__block__title}>{t("Zones")}</h4>

      <div className={styles.driverForm__priority}>
        <Controller
          control={control}
          name={"capacity"}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Input
              value={value}
              onChange={onChange}
              label={t("Orders Capacity")}
              errorMessage={error?.message}
              data-testid="driver--capacity"
              maxLength={150}
              type="number"
            />
          )}
        />
      </div>

      <FormField label={t("Delivery Zones")}>
        <DeliveryZonesFields
          control={control}
          deliveryZones={deliveryZones}
          onAppendDeliveryZone={onAppendDeliveryZone}
          onRemoveDeliveryZone={removeDeliveryZone}
          deliveryZonesOptions={deliveryZonesOptions}
          isDeliveryZonesLoading={isDeliveryZonesLoading}
        />
      </FormField>
      <Button
        icon={<PlusInSquareIcon stroke="#090914" />}
        variant="default"
        onClick={onAppendDeliveryZone}
        data-testid="driver--deliveryZone_addNew"
        type="button"
      >
        {t("Add Delivery Zone")}
      </Button>
    </div>
  );
};
